import { createContext, useContext, useState, useEffect } from "react";
import { TRANSLATIONS } from "./translations";

const LangCtx = createContext(null);
export const SUPPORTED_LANGS = [
  { code: "it", label: "IT", name: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "EN", name: "English", flag: "🇬🇧" },
  { code: "fr", label: "FR", name: "Français", flag: "🇫🇷" },
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
  { code: "de", label: "DE", name: "Deutsch", flag: "🇩🇪" },
];
const STORAGE_KEY = "ds_lang";

const detectLang = () => {
  if (typeof window === "undefined") return "it";
  // 1) URL ?lang=xx ha priorità massima (usato dai QR multilingua)
  try {
    const url = new URL(window.location.href);
    const fromUrl = (url.searchParams.get("lang") || "").toLowerCase();
    if (fromUrl && SUPPORTED_LANGS.some((l) => l.code === fromUrl)) {
      window.localStorage.setItem(STORAGE_KEY, fromUrl);
      return fromUrl;
    }
  } catch (_e) { /* noop */ }
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved && SUPPORTED_LANGS.some((l) => l.code === saved)) return saved;
  const browser = (navigator.language || "it").slice(0, 2).toLowerCase();
  if (SUPPORTED_LANGS.some((l) => l.code === browser)) return browser;
  return "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Resolve a dotted path against translations[lang]
  const t = (path) => {
    const keys = path.split(".");
    let val = TRANSLATIONS[lang];
    for (const k of keys) {
      if (val && typeof val === "object" && k in val) val = val[k];
      else return path;
    }
    return val;
  };

  // Pick from a {it,en,fr,es} object
  const tObj = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.it || "";
  };

  return (
    <LangCtx.Provider value={{ lang, setLang, t, tObj }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
